import { getCookies } from 'utils/cookie';

export default class Logger {
    captureException
    errno
    constructor(release, isSentryActive) {
        if (!isSentryActive) {
            window.appErrno = new window.Errno({appName: 'active-truckers'});
            return;
        }

        const isProd = window.atiEnv.env === 'production';
        const domain = window.atiEnv.baseDomain;

        const cookie = getCookies()['lf_branch']?.toUpperCase();

        let environment;
        if (isProd) {
            environment = cookie ? `production_testing|${cookie}` : 'production';
        } else {
            environment = cookie ? `${domain}_testing|${cookie}` : domain;
        }

        const debug = environment !== 'production';

        window.appErrno = this.errno = new window.Errno({
            dsn: `https://7ee1cfe44f0b4ed6a6967030ca377f89@s1.${domain}/133`,
            environment,
            debug,
            release,
            autoSessionTracking: true,
            integrations: [
                new window.Sentry.Integrations.BrowserTracing(),
            ],
            tracesSampleRate: 0.2,
            ignoreErrors: ['yaCounter', 'window.cb', 'VK is not defined'],
            // eslint-disable-next-line
            allowUrls: [/https?:\/\/(files\.)?ati\.[^.\s\/]+\/(static\/)?active-truckers\/.*/],
            //до 7 версии это свойство называлось так
            // eslint-disable-next-line
            whitelistUrls: [/https?:\/\/(files\.)?ati\.[^.\s\/]+\/(static\/)?active-truckers\/.*/],
        });

        this.captureException = this.errno.captureException;
    }
}
